parseTokenDateTimeDelimeter